'use strict';

import { baseInit, baseInitGpt, baseSetupHeroSkin } from './_base';
import callDealer from '../components/forsale/call-dealer';
import contactForm from '../components/forsale/contact-form';
import saveForLater from '../components/forsale/save-for-later';
import fullScreenGallery from '../components/full-screen-gallery';
import motorwayWidget from '../components/motorway-widget';
import previewSlider from '../components/preview-slider';
import user from '../profile/user';
import foundationLoader from '../utils/foundation-loader';
import logger from '../utils/logger';
import scroll from '../ui/scroll';
import reportAd from '../components/forsale/report-ad';
import parkersCompareLink from '../utils/parkers-compare-links';

const classNames = {
	cfsDetails: 'cfs-details',
	backToSearch: 'back-to-search',
	chargeTimesSelect: 'at-a-glance__charge-times__select',
	chargeTimesInfo: 'at-a-glance__charge-times__info',
	distancePlaceholder: 'distance-placeholder',
	motorwayPromo: 'motorway-promo',
	readMoreSummary: 'read-more__summary',
	readMoreFullText: 'read-more__full-text',
	readMoreToggle: 'read-more__toggle',
	readMoreLink: 'read-more__link',
	readMoreArrow: 'read-more__arrow'
};

const modifierNames = {
	selected: 'selected',
	right: 'right',
	up: 'up'
};

const foundationPlugins = [
	foundationLoader.PLUGINS.ACCORDION,
	foundationLoader.PLUGINS.REVEAL
];

const setDistance = () => {
	const location = user.getLocation();
	const postcode = user.getPostcode();
	if (!location && !postcode) {
		return;
	}

	const cfsId = $.findByBem(classNames.cfsDetails).data('parkers-vehicle-id');
	if (!cfsId) {
		return;
	}

	const endpointSuffix = location
		? `location/${location.latitude}|${location.longitude}`
		: `postcode/${postcode}`;

	$.ajax({
		url: `/api/distance-from-cfs/${cfsId}/${endpointSuffix}`,
		method: 'GET',
		success: (data) => {
			$.findByBem(classNames.cfsDetails, classNames.distancePlaceholder)
				.html(`${data} miles from you`);
		},
		error: (xhr, status, err) => {
			const errorMessage = 'An error occurred while retriving distance: ' + xhr.responseText;
			logger.error(errorMessage, err);
		}
	});
};

const setBackToSearch = () => {
	// May want to only do this for same-site referrers when we have a way to create model search result url for off-site referrers
	const $backLink = $.findByBem(classNames.cfsDetails, classNames.backToSearch);

	if (document.referrer) {
		$backLink.attr('href', document.referrer);
	}

	$backLink.off('click.backToSearch').on('click.backToSearch', (e) => {
		e.preventDefault();
		history.back();
	});
};

const initChargeTimes = () => {
	const $chargeTimesSelect = $.findByBem(classNames.cfsDetails, classNames.chargeTimesSelect);
	const $chargeTimesItems = $.findByBem(classNames.cfsDetails, classNames.chargeTimesInfo);
	$chargeTimesSelect.off('change.chargeTimes').on('change.chargeTimes', () => {
		const selectedVal = $chargeTimesSelect.val();
		$chargeTimesItems.removeBemClass(classNames.cfsDetails, classNames.chargeTimesInfo, modifierNames.selected);

		$chargeTimesItems.filterByBem(classNames.cfsDetails, classNames.chargeTimesInfo, selectedVal)
			.addBemClass(classNames.cfsDetails, classNames.chargeTimesInfo, modifierNames.selected);
	});
};

const isShowingSummary = () => {
	return $.findByBem(classNames.cfsDetails, classNames.readMoreSummary).is(':visible');
}

const collapseDealerComments = ($readMoreLink, $readMoreArrow, $readMoreSummary, $readMoreFullText) => {
	$($readMoreSummary).show();
	$($readMoreFullText).hide();

	$($readMoreLink).text('Read more');
	$($readMoreArrow)
		.addBemClass(classNames.cfsDetails, classNames.readMoreArrow, modifierNames.right)
		.removeBemClass(classNames.cfsDetails, classNames.readMoreArrow, modifierNames.up);
}

const expandDealerComments = ($readMoreLink, $readMoreArrow, $readMoreSummary, $readMoreFullText) => {
	$($readMoreSummary).hide();
	$($readMoreFullText).show();

	$($readMoreLink).text('Read less');
	$($readMoreArrow)
		.addBemClass(classNames.cfsDetails, classNames.readMoreArrow, modifierNames.up)
		.removeBemClass(classNames.cfsDetails, classNames.readMoreArrow, modifierNames.right);
}

const initExpandableText = () => {
	const $readMoreToggle = $.findByBem(classNames.cfsDetails, classNames.readMoreToggle);
	$readMoreToggle.on('click', (event) => {
		event.preventDefault();

		const $readMoreLink = $(event.currentTarget).findByBem(classNames.cfsDetails, classNames.readMoreLink);
		const $readMoreArrow = $($readMoreToggle).findByBem(classNames.cfsDetails, classNames.readMoreArrow);
		const $readMoreSummary = $.findByBem(classNames.cfsDetails, classNames.readMoreSummary);
		const $readMoreFullText = $.findByBem(classNames.cfsDetails, classNames.readMoreFullText);

		if (isShowingSummary()) {
			expandDealerComments($readMoreLink, $readMoreArrow, $readMoreSummary, $readMoreFullText);
		} else {
			collapseDealerComments($readMoreLink, $readMoreArrow, $readMoreSummary, $readMoreFullText);

			// Adjust the scrolling so that the "Dealer's comments" title also comes into view.
			const scrollTopOffset = 50;
			scroll.scrollIfNotInView($readMoreSummary, 200, scrollTopOffset);
		}
	});
}

export function init() {
	baseInit(foundationPlugins);
	callDealer.init();
	contactForm.init();
	fullScreenGallery.init();
	previewSlider.init();
	motorwayWidget.init($.getBemClass(classNames.cfsDetails, classNames.motorwayPromo));
	saveForLater.init('Click Detail Page');
	reportAd.init();
	parkersCompareLink.init();

	setDistance();
	setBackToSearch();
	initChargeTimes();
	initExpandableText();
}

export function initGpt(adConfig) {
	baseInitGpt(adConfig);
}

export function setupHeroSkin(options) {
	baseSetupHeroSkin(options);
}